import React from 'react';
import { InputBaseComponentProps } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { DefaultFormData } from '../../local-types';

interface FormTextAreaProps extends DefaultFormData {
    value: string;
    inputProps?: InputBaseComponentProps;
}

const FormTextArea = ({
    value,
    inputProps,
    disabled,
    required,
    placeholder,
    hint,
    id,
    name,
    label,
    handleChange,
}: FormTextAreaProps): JSX.Element => {
    const classes = useStyles();

    return (
        <FormControl margin="dense" className={classes.flex}>
            <div className={classes.formLabel}>{label}</div>
            <TextareaAutosize
                id={id}
                minRows={5}
                placeholder={placeholder}
                name={name}
                value={value || ''}
                className={classes.formInput}
                required={required}
                disabled={disabled}
                onChange={handleChange}
                {...inputProps}
            />
            {hint && <div className={classes.hint}>{hint}</div>}
        </FormControl>
    );
};

//=====================================//
//=============== Style ===============//
//=====================================//

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        flex: {
            display: 'flex',
            flex: 'inherit',
        },
        formLabel: {
            fontSize: 12,
            color: theme.palette.primary.dark,
            fontWeight: 500,
            paddingBottom: 7,
        },
        formInput: {
            width: '100%',
            minWidth: 200,
            fontFamily: 'Roboto',
            fontSize: 16,
            padding: 8,
        },
        hint: {
            fontSize: 12,
            color: theme.palette.text.secondary,
        },
    }),
);

export default FormTextArea;
